import React, {useContext} from 'react';
import {InputGroup, InputGroupText} from 'reactstrap';
import {FormFieldProps} from '@src/@types/components/Form';
import Input from './Input';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';
import FormattedPrice from '@src/components/FormattedPrice/FormattedPrice';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import {useFormContext} from 'react-hook-form';
import {InputType} from 'reactstrap/types/lib/Input';

export default function PriceField<Model extends IEmptyModel>(props: FormFieldProps<Model> & {
    valueContainerType?: InputType,
}) {
    const {getFieldState, formState} = useFormContext<Model>();
    const [design] = useContext(FormFieldDesignContext);

    const isInvalid = (props as any).isInvalid ?? Boolean(getFieldState(props.fieldName as any, formState).error);

    return <InputGroup size={design?.size} className={isInvalid ? 'is-invalid' : undefined}>
        <InputGroupText>
            <FormattedPrice onlySign/>
        </InputGroupText>
        <Input {...props} type={props.valueContainerType ?? 'number'} step={0.01}/>
    </InputGroup>;
}

PriceField.mutateValueBeforeDisplay = function (value: any): any {
    return value != null ? value / 100 : value;
};
